<form
    #variationDetailForm="ngForm"
    id="variationDetailForm"
    class="form-v2"
    *ngIf="{ isAdjustment: (isAdjustment$ | async)!, label: (label$ | async) } as data">
    <div class="modal-header padding-top-5 padding-bottom-5">
        <h4 class="modal-title">
            {{ data.label }} Details : {{ variation.VariationNo }}
            <p class="modal-sub-title">{{ variation.Job?.FullDescription }}</p>
        </h4>
        <div class="adjustment-dropdown" *ngIf="showAdjustment">
            <span> Type: </span>
            <ng-select
                class="light"
                [items]="variationTypes"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [searchable]="false"
                placeholder="Select from one of the below"
                (change)="variationTypeChange($event)"
                [ngModel]="variation.IsAdjustment"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="false">
            </ng-select>
        </div>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="isVariationInvoiced">
            <div class="col-xs-12">
                <div class="alert alert-info padding-5">
                    This {{ data.label }} has been assigned to the following invoices and is read-only:
                    <span class="margin-left-5" *ngFor="let invoice of invoices; let isLast = last"
                        >{{ invoice.InvoiceNumberString }}{{ !isLast ? ',' : '' }}</span
                    >
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-xs-12">
                <div class="form-group">
                    <label class="text-info"> Description </label>
                    <input
                        legacy-css
                        type="text"
                        class="form-control"
                        placeholder="Description"
                        id="description"
                        name="description"
                        [(ngModel)]="variation.Description"
                        appAutoFocus
                        appSelectAllOnFocus
                        [appSelectAllOnFocusFilter]="'New ' + translations.variation"
                        maxlength="8000"
                        required
                        [readonly]="isVariationInvoiced" />
                </div>
            </div>
            <div class="col-md-4 col-xs-12">
                <div class="form-group">
                    <label class="text-info"> Status </label>
                    <ng-select
                        class="light variation-status-select"
                        name="status"
                        [disabled]="!permissions.canEditStatus || isVariationInvoiced"
                        [items]="statuses"
                        #status="ngModel"
                        bindValue="name"
                        [searchable]="false"
                        (change)="statusChanged()"
                        [clearable]="false"
                        [(ngModel)]="variation.Status">
                        <ng-template ng-label-tmp let-item="item">
                            <div>
                                <span
                                    class="label variation-status-label"
                                    [ngClass]="{
                                        'label-inverse': variation.Status === 'Pending',
                                        'label-warning': variation.Status === 'Sent',
                                        'label-success': variation.Status === 'Accepted' || variation.Status === 'Digitally Accepted',
                                        'label-danger': variation.Status === 'Rejected',
                                    }"
                                    >{{ variation.Status }}</span
                                >
                            </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.name }}
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!showAdjustment || !variation.IsAdjustment">
            <div class="col-xs-8">
                <div class="form-group">
                    <label class="text-info"> Proposed Start </label>
                    <input
                        legacy-css
                        bsDatepicker
                        class="form-control"
                        [bsConfig]="{
                            adaptivePosition: true,
                            showWeekNumbers: false,
                            containerClass: 'theme-default',
                            customTodayClass: 'bsdatepicker-today',
                            dateInputFormat: locale,
                        }"
                        placeholder="Select a date"
                        type="text"
                        [(ngModel)]="variation.StartDate"
                        id="startDate"
                        name="startDate" />
                </div>
            </div>
            <div class="col-xs-4">
                <div class="form-group">
                    <label class="text-info"> Delay Days </label>
                    <input
                        legacy-css
                        type="text"
                        class="form-control"
                        id="timeDelay"
                        name="timeDelay"
                        [(ngModel)]="variation.TimeDelay"
                        appNullReplace="0"
                        appNumeric
                        appSelectAllOnFocus
                        [decimals]="0"
                        [readonly]="isVariationInvoiced" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label class="text-info"> Details </label>
                    <textarea
                        legacy-css
                        class="form-control"
                        id="details"
                        name="details"
                        [(ngModel)]="variation.Details"
                        style="min-height: 75px"
                        [readonly]="isVariationInvoiced"></textarea>
                </div>
            </div>
        </div>

        <div class="panel panel-white">
            <div class="panel-heading border-light">
                <h4 class="panel-title">
                    {{ itemCount() }} Item<span *ngIf="itemCount() !== 1">s</span>/Task<span *ngIf="itemCount() !== 1">s</span>
                </h4>
                <ul class="panel-heading-tabs border-light">
                    <li *ngIf="editing && permissions.canModifyVariation">
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-bx-primary"
                                style="min-width: 30px"
                                (appSingleClick)="addItem()"
                                tooltip="Add item"
                                container="body">
                                <i class="ti-plus"></i>
                            </button>
                        </div>
                    </li>
                    <li>
                        <h4 class="panel-title margin-top-15">
                            {{ data.label }} Total (Incl)
                            <strong>{{ variation.TotalIncTax | bxCurrency }}</strong>
                        </h4>
                    </li>
                </ul>
            </div>
            <div class="panel-body" id="panelbody">
                <div class="alert alert-warning padding-5 margin-0" *ngIf="validateCategories()">
                    Please indicate which category the highlighted items should go into. Leaving this field blank will place the items in a
                    new category
                </div>
                <div class="table-responsive">
                    <table class="table table-white">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Description</th>
                                <th></th>
                                <th class="text-left" *ngIf="variation.Job?.CalculationMethod! >= 1">Type</th>
                                <th class="text-right">Qty</th>
                                <th class="text-right">Unit Cost (Ex)</th>
                                <th class="text-center">UOM</th>
                                <th class="text-right">Total Cost (Ex)</th>
                                <th class="text-center" *ngIf="variation.Job?.CalculationMethod! >= 1">{{ taxCode }}</th>
                                <th class="text-right" *ngIf="variation.Job?.InvoiceMethod !== 1">Markup %</th>
                                <th>Actuals Category</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="variation-items-table-body" cdkDropList (cdkDropListDropped)="dropVariationItem($event)">
                            <ng-container
                                *ngFor="
                                    let item of variation.JobVariationTasks! | simpleFilter: { IsDeleted: false } | simpleSort: 'Order';
                                    let i = index
                                ">
                                <ng-template #costItemInfoTooltipTemplate let-model="item" let-index="index" let-query="query">
                                    <p>{{ model.CostItem?.Details }}</p>
                                    <div *ngIf="model.CostItem?.CostBreakdown">
                                        <p><strong>Cost Breakdown:</strong><br />{{ model.CostItem?.getCostBreakdownAsString() }}</p>
                                    </div>
                                </ng-template>
                                <tr id="itemRow{{ item.ID_JobVariationTask }}" cdkDrag cdkDragBoundary=".variation-items-table-body">
                                    <td>
                                        <div class="grip-container">
                                            <span class="grip" cdkDragHandle></span>
                                        </div>
                                    </td>
                                    <td class="condensed-col col-xs-5">
                                        <span *ngIf="!editing">{{ item.Description }}</span>
                                        <span
                                            *ngIf="!editing && item.CostItem?.HasInformation"
                                            class="margin-left-10"
                                            style="cursor: pointer"
                                            [tooltip]="costItemInfoTooltipTemplate"
                                            placement="bottom"
                                            container="body"
                                            triggers="outsideClick"
                                            containerClass="cost-item-info"
                                            ><i class="text-primary text-large fa fa-info-circle"></i
                                        ></span>
                                        <div class="input-group input-group-sm" *ngIf="editing">
                                            <ng-template #costItemTemplate let-model="item" let-index="index" let-query="query">
                                                <div>
                                                    <span class="type-description">
                                                        <span [hidden]="!model.isRecipe"><i class="ti-layers-alt"></i></span>
                                                        <span [hidden]="!model.itemCode">{{
                                                            model.itemCode + (model.itemCode ? ' - ' : '')
                                                        }}</span>
                                                        <span>{{ model.description }}</span>
                                                    </span>
                                                    <span [hidden]="!model.logo"><img src="{{ model.logo }}" /></span>
                                                    <span class="small">{{ model.unitCost | bxCurrency }}</span>
                                                    <span class="small">{{ model.uOM }}</span>
                                                    (<span class="small">{{ model.priceListDescription }}</span> &gt;
                                                    <span class="small">{{ model.costItemCategory }}</span> &gt;
                                                    <span class="small">{{ model.costItemSubCategory }}</span
                                                    >)
                                                </div>
                                            </ng-template>
                                            <input
                                                legacy-css
                                                required
                                                id="{{ item.ID_JobVariationTask }}"
                                                type="text"
                                                [typeahead]="costItemSuggestions$"
                                                [typeaheadAsync]="true"
                                                (typeaheadOnSelect)="setCostItem(item, $event)"
                                                [typeaheadItemTemplate]="costItemTemplate"
                                                typeaheadOptionField="description"
                                                [typeaheadIsFirstItemActive]="false"
                                                container="body"
                                                [typeaheadMinLength]="3"
                                                [(ngModel)]="item.Description"
                                                [ngModelOptions]="{ standalone: true }"
                                                (ngModelChange)="setupCostItems($event)"
                                                [adaptivePosition]="true"
                                                class="form-control"
                                                appNullReplace="New Item"
                                                appSelectAllOnFocus
                                                appSelectAllOnFocusFilter="New Item"
                                                [typeaheadWaitMs]="500"
                                                maxlength="255" />
                                            <span class="input-group-btn">
                                                <button
                                                    *ngIf="item.CostItem?.HasInformation"
                                                    class="btn btn-default btn-cost-item-info"
                                                    type="button"
                                                    [tooltip]="costItemInfoTooltipTemplate"
                                                    placement="bottom"
                                                    container="body"
                                                    triggers="outsideClick"
                                                    containerClass="cost-item-info">
                                                    <i class="text-primary text-large fa fa-info-circle"></i>
                                                </button>
                                                <button type="button" class="btn btn-default" (click)="showCostItemsModal(item)">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="condensed-col">
                                        <app-catalogue-item-link-tile
                                            [item]="item"
                                            *ngIf="item.CostItem?.PriceList?.ShortCode"
                                            (costItemChanged)="setCostItem(item, $event)"
                                            [excludeRecipes]="true"
                                            class="variation-task-price-list-tile"
                                            [tileColour]="item.CostItem?.PriceList?.Colour">
                                        </app-catalogue-item-link-tile>

                                        <app-ui-item-code-pill
                                            [itemState]="item"
                                            *ngIf="!item.CostItem && item.ItemCode"
                                            [actionsEnabled]="true"
                                            (itemCodeCleared)="clearItemCode(item)">
                                        </app-ui-item-code-pill>
                                    </td>
                                    <td
                                        class="condensed-col text-left"
                                        style="min-width: 112px; width: 112px"
                                        *ngIf="variation.Job?.CalculationMethod! >= 1">
                                        <span *ngIf="!editing">{{ taxService.costItemTypeToDisplay(item.CostItemType) }}</span>
                                        <select
                                            legacy-css
                                            *ngIf="editing"
                                            class="form-control"
                                            [(ngModel)]="item.CostItemType"
                                            [ngModelOptions]="{ standalone: true }">
                                            <option *ngFor="let c of taxService.allCostItemTypePairs()" [ngValue]="c.cit">
                                                {{ c.display }}
                                            </option>
                                        </select>
                                    </td>
                                    <td class="condensed-col text-right min-width-140 width-140">
                                        <span *ngIf="!editing">{{ item.Units | imperial: item.IsImperial }}</span>
                                        <div class="input-group input-group-sm" *ngIf="editing">
                                            <input
                                                legacy-css
                                                type="text"
                                                appNumeric
                                                [decimals]="3"
                                                class="form-control padding-5 text-right"
                                                [(ngModel)]="item.Units"
                                                [ngModelOptions]="{ standalone: true }"
                                                [imperial]="item.IsImperial"
                                                appNullReplace="0"
                                                appSelectAllOnFocus
                                                [min]="-9999999" />
                                            <span class="input-group-btn">
                                                <button
                                                    type="button"
                                                    class="btn btn-default btn-default--is-narrow"
                                                    (click)="showCalculator(item)"
                                                    tooltip="Calculator">
                                                    <span
                                                        class="badge badge-info wastage-badge"
                                                        *ngIf="item.HasWastage"
                                                        tooltip="Wastage has been added to this item"
                                                        container="body"
                                                        >w</span
                                                    >
                                                    <i class="fa fa-calculator"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-default btn-default--is-narrow"
                                                    *ngIf="isTakeOffAvailable"
                                                    (click)="doTakeOff(item)"
                                                    tooltip="Takeoff Tool">
                                                    <i class="ti-ruler-alt-2"></i>
                                                </button>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="condensed-col text-right min-width-80 width-80">
                                        <span *ngIf="!editing">{{ item.UnitCost | bxCurrency }}</span>
                                        <input
                                            legacy-css
                                            type="text"
                                            *ngIf="editing"
                                            class="form-control text-right"
                                            [(ngModel)]="item.UnitCost"
                                            [ngModelOptions]="{ standalone: true }"
                                            appCurrency
                                            appSelectAllOnFocus />
                                    </td>
                                    <td class="condensed-col text-center min-width-60 width-60">
                                        <span *ngIf="!editing">{{ item.UOM }}</span>
                                        <input
                                            legacy-css
                                            type="text"
                                            *ngIf="editing"
                                            maxlength="50"
                                            container="body"
                                            [ngModelOptions]="{ standalone: true }"
                                            [(ngModel)]="item.UOM"
                                            [typeahead]="unitMeasures"
                                            typeaheadOptionField="Description"
                                            class="form-control"
                                            [typeaheadMinLength]="1" />
                                    </td>
                                    <td class="condensed-col text-right min-width-80 width-80">{{ item.TotalCost | bxCurrency }}</td>
                                    <td
                                        class="condensed-col text-center min-width-80 width-80"
                                        *ngIf="variation.Job?.CalculationMethod! >= 1">
                                        <tax-rate-selector
                                            [editable]="editing"
                                            [taxType]="0"
                                            [costItemType]="item.CostItemType"
                                            [selectedTaxCodes]="item.TaxRates"
                                            [taxRatesParent]="variation"
                                            (selectedChanged)="taxRatesChanged($event, item)"
                                            [placement]="'left'"></tax-rate-selector>
                                    </td>
                                    <td class="condensed-col text-right min-width-60 width-60" *ngIf="variation.Job?.InvoiceMethod !== 1">
                                        <span *ngIf="!editing">{{ item.Markup | number: '1.2-2' }}</span>
                                        <input
                                            legacy-css
                                            type="text"
                                            *ngIf="editing"
                                            class="form-control text-right"
                                            [(ngModel)]="item.Markup"
                                            [ngModelOptions]="{ standalone: true }"
                                            appNumeric
                                            appSelectAllOnFocus
                                            [decimals]="2"
                                            appNullReplace="0"
                                            [min]="-1000"
                                            [max]="1000" />
                                    </td>
                                    <td class="condensed-col text-center min-width-80 width-80">
                                        <span *ngIf="!editing">{{ item.ParentTask }}</span>
                                        <div class="typeahead-right-align" [ngClass]="{ 'validation-warning-solid': !item.ParentTask }">
                                            <input
                                                legacy-css
                                                type="text"
                                                *ngIf="editing"
                                                maxlength="300"
                                                container="body"
                                                [(ngModel)]="item.ParentTask"
                                                [ngModelOptions]="{ standalone: true }"
                                                [typeahead]="parentTasks"
                                                typeaheadOptionField="Description"
                                                class="form-control"
                                                [typeaheadMinLength]="0"
                                                (typeaheadOnSelect)="setParentTaskId(item, $event)"
                                                (change)="setParentTaskIdOnChange(item)"
                                                [typeaheadWaitMs]="10"
                                                [typeaheadIsFirstItemActive]="false" />
                                        </div>
                                    </td>
                                    <td class="condensed-col text-right min-width-60 width 60">
                                        <button
                                            type="button"
                                            class="btn btn-xs"
                                            [ngClass]="{ 'btn-default': !item.ShowInSchedule, 'btn-light-blue': item.ShowInSchedule }"
                                            (click)="toggleShowInSchedule(item)"
                                            tooltip="Show as task in job schedule"
                                            container="body">
                                            T
                                        </button>
                                        <a
                                            *ngIf="editing"
                                            (click)="deleteItem(item)"
                                            class="btn btn-xs btn-danger margin-left-5"
                                            tooltip="Delete item"
                                            container="body"
                                            ><i class="ti-trash"></i
                                        ></a>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <div class="row margin-top-15">
                    <div class="col-md-offset-6 col-md-6 col-xs-12">
                        <div class="row">
                            <div class="col-xs-6 text-right">
                                <span class="text-large--variation">Sub Total</span>
                            </div>
                            <div class="col-xs-6 text-right">
                                <span class="text-large--variation">{{ variation.Amount | bxCurrency }}</span>
                            </div>
                        </div>
                        <div class="row margin-top-5" *ngIf="variation.FranchiseFeeTotal">
                            <div class="col-xs-6 form-inline text-right">
                                <span class="text-large--variation"><em>Inc. Franchise Fee</em></span>
                            </div>
                            <div class="col-xs-6 text-right">
                                <span class="text-large--variation"
                                    ><em>{{ variation.FranchiseFeeTotal | bxCurrency }}</em></span
                                >
                            </div>
                        </div>
                        <div class="row margin-top-5">
                            <div class="col-xs-6 form-inline text-right">
                                <span class="text-large--variation">{{ taxCode }}</span>
                            </div>
                            <div class="col-xs-6 text-right">
                                <span class="text-large--variation">{{ variation.Tax | bxCurrency }}</span>
                            </div>
                        </div>
                        <div class="row margin-top-5">
                            <div class="col-xs-6 text-right">
                                <span class="text-large--variation">{{ data.label }} Total (Inc)</span>
                            </div>
                            <div class="col-xs-6 text-right">
                                <span class="text-large--variation"
                                    ><strong>{{ variation.TotalIncTax | bxCurrency }}</strong></span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
        <button
            type="button"
            class="btn-bx-secondary ml-2"
            (click)="ok()"
            [disabled]="!variationDetailForm.valid"
            *ngIf="permissions.canModifyVariation">
            Save &amp; Close
        </button>
        <button
            type="button"
            class="btn-bx-primary ml-2"
            (click)="ok(true)"
            [disabled]="!variationDetailForm.valid"
            *ngIf="permissions.canModifyVariation && permissions.canSendVariation">
            Save &amp; Share
        </button>
    </div>
</form>
